import { useState } from 'react'
import classNames from 'classnames'
import './styles.scoped.sass'

import { ReactComponent as ArrowDown } from '@/assets/icons/arrow-down.svg'

export default function MessageHeadersPanel ({ headers }) {
  const [display, setDisplay] = useState(false)
  const notHiddenHeaders = [
    'From:',
    'To:',
    'Reply-To:',
    'Date:',
    'Subject:',
    'Cc:',
    'Bcc:',
    'x-ses-spam-verdict:',
    'x-ses-virus-verdict:',
  ]
  return (
    <div>
      <div className="panel-button" onClick={() => setDisplay(!display)}>
        <ArrowDown />
      </div>
      <div className={classNames('panel', { hidden: !display })}>
        {headers && notHiddenHeaders.map((key, i) => {
          if (!headers[key]) return undefined
          return (
            <div key={i} className='row'>
              <div className="left">{key}</div>
              <div className="right" title={headers[key].trim()}>{headers[key].trim()}</div>
            </div>
          )
        })}
      </div>
      { display && <div className='side-menu-backdrop' onClick={() => setDisplay(false)}></div>}
    </div>
  )
}
